import React from 'react'

const ModelSettingsIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <rect className='custom-icon-stroke' x="1" y="1" width="22" height="22" rx="5.5" stroke="white"/>
        <path className='custom-icon' fillRule="evenodd" clipRule="evenodd" d="M18 6.5H21V5.5H17.7324C17.9026 5.79417 18 6.13571 18 6.5ZM14.2676 5.5C14.0974 5.79417 14 6.13571 14 6.5L3 6.5V5.5H14.2676Z" fill="white"/>
        <path className='custom-icon' fillRule="evenodd" clipRule="evenodd" d="M9.5 12.5L21 12.5V11.5H9.23244C9.40261 11.7942 9.5 12.1357 9.5 12.5ZM5.76756 11.5C5.59739 11.7942 5.5 12.1357 5.5 12.5H3V11.5H5.76756Z" fill="white"/>
        <path className='custom-icon' fillRule="evenodd" clipRule="evenodd" d="M20.5 18L21 18V17H20.2324C20.4026 17.2942 20.5 17.6357 20.5 18ZM16.7676 17H3V18H16.5C16.5 17.6357 16.5974 17.2942 16.7676 17Z" fill="white"/>
        <circle className='custom-icon-stroke' cx="15.75" cy="6.25" r="1.75" stroke="white"/>
        <circle className='custom-icon-stroke' cx="7.25" cy="12.25" r="1.75" stroke="white"/>
        <circle className='custom-icon-stroke' cx="18.25" cy="17.75" r="1.75" stroke="white"/>
        <line className='custom-icon-stroke' x1="21" y1="12" x2="22.5" y2="12" stroke="white"/>
        <line className='custom-icon-stroke' x1="21" y1="6" x2="22.5" y2="6" stroke="white"/>
        <line className='custom-icon-stroke' x1="21" y1="17.5" x2="22.5" y2="17.5" stroke="white"/>
        <line className='custom-icon-stroke' x1="1.5" y1="12" x2="3" y2="12" stroke="white"/>
        <line className='custom-icon-stroke' x1="1.5" y1="6" x2="3" y2="6" stroke="white"/>
        <line className='custom-icon-stroke' x1="1.5" y1="17.5" x2="3" y2="17.5" stroke="white"/>
    </svg>
  )
}

export default ModelSettingsIcon
